import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'merz',
} as IModuleProps;
